import { render, staticRenderFns } from "./DialogAddCompetitor.vue?vue&type=template&id=5a18c308&scoped=true"
import script from "./DialogAddCompetitor.vue?vue&type=script&lang=js"
export * from "./DialogAddCompetitor.vue?vue&type=script&lang=js"
import style0 from "./DialogAddCompetitor.vue?vue&type=style&index=0&id=5a18c308&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18c308",
  null
  
)

export default component.exports